import { ChangeDetectorRef, Component } from '@angular/core';
import { TranslateFormatText } from '../../helpers/array.helpers';
import { TranslateHelper } from '../../helpers/injector.helper';
import { TranslatedString } from '../../models/translatedstring.model';
import { NumberCircleService } from '../../services/numbercircle.service';
import { DataCheck } from '../../workflow/workflow.dialog';
import { BaseListDetail, BaseListSettings, DeleteTexts, SaveTexts } from '../base.list.settings';

@Component({
    selector: 'numbercircle-settings',
    templateUrl: '../base.list.settings.html'
})
export class NumberCircleSettings extends BaseListSettings {

    static GetSettingsEntry() {
        return {
            Caption: '@@Nummernkreise',
            ID: 'numbercircles',
            Icon: 'file-digit',
            Index: 50,
            Parent: 'data',
            Content: NumberCircleSettings
        };
    }

    constructor(protected cdRef: ChangeDetectorRef, private service: NumberCircleService) {
        super(cdRef);
    }

    loadList(handler: any) {
        this.service.GetNumberInfos().subscribe(result => {
            if (result) {
                const list = [];
                result.forEach(item => {
                    list.push({
                        Caption: item.Caption,
                        ID: item.SID,
                        IsCapsule: item.IsCapsule,
                        IsOverridden: item.IsOverridden
                    });
                });
                handler(list);
            }
        });
    }
    loadData(data: any) {
        this.service.GetNumberDetailInfo(data).subscribe(x => {
            if (x) {
                this.setSelectedItem(x.NumberCircle);
                if (this.Component) {
                    this.Component.ActualNumber = x.ActualNumber;
                }
            }
        });
    }
    getNewItem() {
        return {
            StartNumber: 0,
            FormatString: '{0}'
        };
    }
    getDeleteText(sel: any): DeleteTexts {
        const retVal = new DeleteTexts();
        retVal.Question = new TranslateFormatText('@@Sind Sie sicher, dass Sie den Nummernkreis \'{0}\' loeschen moechten?');
        retVal.Question.FormatParams.push(sel.Caption);
        retVal.Success = new TranslateFormatText('@@Nummernkreis \'{0}\' erfolgreich geloescht.');
        retVal.Success.FormatParams.push(sel.Caption);
        retVal.Title = new TranslateFormatText('@@Nummernkreis loeschen');
        return retVal;
    }
    delete(data: any, handler: any) {
        this.service.DeleteNumbers(data).subscribe(() => {
            handler();
        });
    }
    getSaveSuccessText(sel: any): SaveTexts {
        let caption = TranslatedString.GetTranslation(sel.Caption);
        if (!caption) {
            caption = sel.Name;
        }
        const retVal = new SaveTexts();
        retVal.Text = new TranslateFormatText('@@Nummernkreis \'{0}\' erfolgreich gespeichert.');
        retVal.Text.FormatParams.push(caption);
        retVal.Title = new TranslateFormatText('@@Nummernkreis speichern');
        return retVal;
    }
    saveInternal(item: any, handler: any) {
        this.service.SaveNumbers(item).subscribe(x => {
            if (x) {
                handler(x, x.SID, x.Caption);
            }
        });
    }
    getContentType() {
        return NumberCircleDetail;
    }
    handleNew(item, result) {
        item.SID = result.SID;
        item.Version = result.Version;
        if(this.Component) {
            this.Component.ActualNumber = result.ActualNumber;
        }
    }
    updateListItem(item, result) {
        item.IsCapsule = result.IsCapsule;
        item.IsOverridden = result.IsOverridden;
    }
    protected async checkCanSave(): Promise<DataCheck> {
        const retVal = new DataCheck();
        if (this.Component) {
            const selItem = this.Component.SelectedItem;
            if (selItem) {
                if (!selItem.Name || typeof selItem.StartNumber !== 'number') {
                    retVal.IsCorrect = false;
                    retVal.Error = TranslateHelper.TranslatorInstance.instant('@@Bitte vergeben Sie einen Namen und eine Startnummer');
                }
            }
        }
        return retVal;
    }
}

@Component({
    selector: 'numbercircle-detail',
    templateUrl: './numbercircle.settings.html'
})
export class NumberCircleDetail extends BaseListDetail {
    ActualNumber = '';

    setSelectedItem(item) {
        super.setSelectedItem(item);
        this.ActualNumber = '';
    }
}
